document.addEventListener("DOMContentLoaded", function () {

  $(".page-support #nt_content,.page-new-faqs #nt_content,.template-search #nt_content").bind("click", function (evt) {
    if ($(evt.target).closest(".Support-Quickoutbox predictive-searchse").length == 0) {
      console.log('clicked outside');
      if ($('.Support-Quickoutbox predictive-searchse #predictive-search').is(':hidden')) {

      } else {
        $('.Support-Quickoutbox predictive-searchse #predictive-search').hide();
      }
    }
  });


});


document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.querySelector('input.input-supportfm');
  const searchForm = document.querySelector('form.supportfm-wrapper');
  const predictiveContainer = document.querySelector('#predictive-search');

  // ✅ 提交后存入 localStorage
  if (searchForm) {
    searchForm.addEventListener('submit', function (event) {
      const term = searchInput.value.trim();
      if (term !== '') {
        let history = JSON.parse(localStorage.getItem('search_history') || '[]');
        history = history.filter(item => item !== term); // 去重
        history.unshift(term); // 最新的放前面
        if (history.length > 3) history = history.slice(0, 3); // 保留最多3条
        localStorage.setItem('search_history', JSON.stringify(history));
      }
    });
  }

  // ✅ 输入框为空且聚焦时获取默认搜索建议
  function fetchDefaultSuggestions() {
    const history = JSON.parse(localStorage.getItem('search_history') || '[]');

    // 启动条件：输入框为空 且 聚焦 且 有历史记录
    if (searchInput.value.trim() === '' && history.length > 0 && document.activeElement === searchInput) {
      fetch('/search/suggest?q=1&section_id=predictive-searchse')
        .then(response => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(html => {
          // 创建临时 DOM
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;

          // 获取 .quicklink-wrapper 和 #search-history
          const searchHistoryContainer = tempDiv.querySelector('#search-history');

          if (searchHistoryContainer) {
            searchHistoryContainer.style.display = 'block';
            searchHistoryContainer.innerHTML = `
              <div class="quicklink-title suggested-title">Recent Searches</div>
              ${history.map(term => `
                <div class="search-history-item serachitems">
                  <a href="/search?q=${encodeURIComponent(term)}">${term}</a>
                </div>
              `).join('')}
            `;
          }

          // 给最外层元素添加 .history_cus 类
          const outerWrapper = tempDiv.firstElementChild || tempDiv;
          outerWrapper.classList.add('history_cus');

          // 输出到 #predictive-search
          if (predictiveContainer) {
            predictiveContainer.innerHTML = tempDiv.innerHTML;
            $("#predictive-search").show();
          }
        })
        .catch(err => console.error('Fetch 出错:', err));
    }
  }

  // ✅ 输入框聚焦或变化时触发检查
  searchInput.addEventListener('focus', fetchDefaultSuggestions);

});
